import {
  MdHome,
  MdAdminPanelSettings,
  MdSettings,
  MdCalendarToday,
  MdHowToReg,
  MdMenuBook,
  MdAccountBalance,
  MdLibraryBooks,
  MdForum,
  MdGroupWork,
  MdStar,
  MdPayment,
  MdAccountCircle,
  MdWorkOutline,
  MdOutlineSchool,
} from "react-icons/md";

import Dashboard from "./views/admin/default";
import PromotionManager from "views/admin/promotion";
import AnneUniversitaireManager from "views/admin/annee_universitaire";
import RoleManager from "views/admin/role";
import NiveauManager from "views/admin/niveaux";
import ParcoursManager from "views/admin/parcours";
import MentionManager from "views/admin/mentions";
import DroitParticipationManager from "views/admin/droit_participation";
import DepenseManager from "views/admin/depense_compte";
import MemoireManager from "views/admin/memoire_these";
import SosialyManager from "views/admin/sosialy";
import UserManager from "views/admin/utilisateur";
import InscriptionManager from "views/admin/inscription";

const routes = [
  {
    name: "Tableau de bord",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    requiredRole: ["Admin", "tresorier", "rad", "membre"],
    component: <Dashboard />,
  },
  {
    name: "Gestion des membres",
    layout: "/admin",
    path: "membres",
    icon: <MdHowToReg className="h-6 w-6" />,
    requiredRole: ["Admin"],
    component: <InscriptionManager />,
  },
  {
    name: "Gestion des utilisateurs",
    layout: "/admin",
    path: "utilisateurs",
    icon: <MdAccountCircle className="h-6 w-6" />,
    requiredRole: ["Admin", "tresorier"],
    component: <UserManager />,
  },
  {
    name: "Gestion des activités",
    layout: "/admin",
    path: "activites",
    icon: <MdWorkOutline className="h-6 w-6" />,
    requiredRole: ["Admin"],
    component: <RoleManager />,
  },

  {
    name: "Gestion de la caisse",
    layout: "/admin",
    path: "caisse",
    icon: <MdAccountBalance className="h-6 w-6" />,
    requiredRole: ["Admin", "tresorier"],
    component: <DepenseManager />,
  },
  {
    name: "Gestion des mémoires",
    layout: "/admin",
    path: "memoires-theses",
    requiredRole: ["Admin", "tresorier", "rad", "membre"],
    component: <MemoireManager />,
    icon: <MdLibraryBooks className="h-6 w-6" />,
  },
  {
    name: "Gestion des réseaux sociaux",
    layout: "/admin",
    path: "sosialy",
    requiredRole: ["Admin", "tresorier"],
    component: <SosialyManager />,
    icon: <MdForum className="h-6 w-6" />,
  },
  {
    name: "Paramètres",
    layout: "/admin",
    icon: <MdSettings className="h-6 w-6" />,
    secondary: true,
    requiredRole: ["Admin", "tresorier"],
    isAccordion: true,
    children: [
      {
        name: "Gestion des promotions",
        layout: "/admin",
        path: "promotions",
        requiredRole: ["Admin", "tresorier"],
        component: <PromotionManager />,
        icon: <MdGroupWork className="h-6 w-6 text-amber-500" />,
      },
      {
        name: "Gestion des années universitaires",
        layout: "/admin",
        path: "annees-universitaires",
        requiredRole: ["Admin", "tresorier"],
        component: <AnneUniversitaireManager />,
        icon: <MdCalendarToday className="h-6 w-6 text-amber-500" />,
      },
      {
        name: "Gestion des rôles",
        layout: "/admin",
        path: "roles",
        requiredRole: ["Admin"],
        component: <RoleManager />,
        icon: <MdAdminPanelSettings className="h-6 w-6 text-red-500" />,
      },
      {
        name: "Gestion des niveaux",
        layout: "/admin",
        path: "niveaux",
        requiredRole: ["Admin", "tresorier"],
        component: <NiveauManager />,
        icon: <MdOutlineSchool className="h-6 w-6 text-blue-500" />, // Icône corrigée
      },
      {
        name: "Gestion des mentions",
        layout: "/admin",
        path: "mentions",
        requiredRole: ["Admin", "tresorier"],
        component: <MentionManager />,
        icon: <MdStar className="h-6 w-6 text-green-500" />,
      },
      {
        name: "Gestion des parcours",
        layout: "/admin",
        path: "parcours",
        requiredRole: ["Admin", "tresorier"],
        component: <ParcoursManager />,
        icon: <MdMenuBook className="h-6 w-6 text-[#4a9154]" />,
      },
      {
        name: "Gestion des droits",
        layout: "/admin",
        path: "droits",
        requiredRole: ["Admin", "tresorier"],
        component: <DroitParticipationManager />,
        icon: <MdPayment className="h-6 w-6 text-[#4a9154]" />,
      },
    ],
  },
];

export default routes;